import { useOutletContext } from "react-router-dom";
import WorkspacesTable from "../../components/adminDashboard/ui/workspaces/WorkspacesTable.jsx";
import WorkspaceOnboarding from "../../components/adminDashboard/ui/workspaces/WorkspaceOnboarding.jsx";

export default function WorkSpaces() {
  const {
    workspacesData,
    workspaceSearchQuery,
    setWorkspaceSearchQuery,
    isWorkspaceOnboarding,
    setIsWorkspaceOnboarding,
    workspaceOnboardStep,
    setWorkspaceOnboardStep,
    newWorkspaceData,
    setNewWorkspaceData,
    companiesData,
    handleFinishWorkspaceOnboarding,
    selectedWorkspaceDetails,
    setSelectedWorkspaceDetails,
    fetchWorkWorkspaces
  } = useOutletContext();
  return (
    <>
      {!isWorkspaceOnboarding && (
        <WorkspacesTable
          workspaces={workspacesData}
          searchQuery={workspaceSearchQuery}
          setSearchQuery={setWorkspaceSearchQuery}
          isWorkspaceOnboarding={isWorkspaceOnboarding}
          setIsWorkspaceOnboarding={setIsWorkspaceOnboarding}
          setSelectedWorkspaceDetails={setSelectedWorkspaceDetails}
          fetchWorkWorkspaces={fetchWorkWorkspaces}
        />
      )}
      {(isWorkspaceOnboarding || selectedWorkspaceDetails) && (
        <WorkspaceOnboarding
          step={workspaceOnboardStep}
          setStep={setWorkspaceOnboardStep}
          data={newWorkspaceData}
          setData={setNewWorkspaceData}
          companies={companiesData}
          onFinish={handleFinishWorkspaceOnboarding}
          selectedWorkspaceDetails={selectedWorkspaceDetails}
        />
      )}
    </>
  );
}
